<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        
        <el-form-item label="评论时间">
          <el-date-picker
            v-model="filters.beginDate"
            :clearable=false
            :editable=false
            placeholder="开始日期"
            type="datetime">
          </el-date-picker>
          <el-date-picker
            v-model="filters.endDate"
            :clearable=false
            :editable=false
            placeholder="开始日期"
            type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="filters.status" style="width: 150px;" @change="getInitList">
            <el-option label="未审核" value="0"></el-option>
            <el-option label="已审核" value="1"></el-option>
            <el-option label="已删除" value="-1"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="评价类型">
            <el-select v-model="filters.type" style="width: 150px;" @change="getInitList">
              <el-option label="全部" value=""></el-option>
              <el-option label="医博士" value="1_0"></el-option>
              <el-option label="资讯" value="2_0"></el-option>
              <el-option label="短视频" value="3_0"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getInitList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="buttonsAccess.indexOf('批量审核') > -1 && filters.status !== '-1'" type="primary"
            @click="handleAuditing">批量审核
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="buttonsAccess.indexOf('批量取消审核') > -1 && filters.status !== '-1'"
            type="primary" @click="handleCancelAuditing">
            批量取消审核
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="buttonsAccess.indexOf('批量删除') > -1 && filters.status !== '-1'" type="primary"
            @click="handleDelBatch">批量删除
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table v-loading="listLoading" :data="commentList" border
      highlight-current-row style="width: 100%;" @selection-change="handleSelectionChange"
      @cell-click="handleReplayList">
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column label="评论内容" prop="contentReal" show-overflow-tooltip width="500">
      </el-table-column>
      <el-table-column label="所属课程/资讯" prop="ojbName" width="200">
      </el-table-column>
        <el-table-column label="评价类型" prop="type" width="80">
          <template slot-scope="scope">
            <span>{{tyypeum[scope.row.type]}}</span>
          </template>
        </el-table-column>
      <el-table-column label="评论人" min-width="80" prop="userInfo.realName">
      </el-table-column>
      <el-table-column label="评论时间" min-width="140" prop="createTime">
      </el-table-column>
      <el-table-column label="回复状态" min-width="80" prop="replayStatus">
      </el-table-column>
      <el-table-column label="培训年份" min-width="80" prop="year">
      </el-table-column>
      <el-table-column label="培训名称" min-width="150" prop="trainingName">
      </el-table-column>
      <el-table-column label="项目名称" min-width="150" prop="projectName">
      </el-table-column>
      <el-table-column label="手机号" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="省" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.provinceName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="市" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.cityName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="县" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.countyName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="乡" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.ruralName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单位" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.userInfo.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="buttonsAccess.indexOf('操作-回复') > -1 || buttonsAccess.indexOf('操作-预览') > -1 || buttonsAccess.indexOf('操作-删除') > -1"
        fixed="right" label="操作"
        width="210">
        <template slot-scope="scope">
          <el-button v-if="buttonsAccess.indexOf('操作-回复') > -1 && filters.status !== '-1'" size="small"
            type="primary"
            @click="handleReplay(scope.$index, scope.row)" :disabled="scope.row.type==3">回复
          </el-button>
          <el-button v-if="buttonsAccess.indexOf('操作-预览') > -1" size="small" type="danger"
            @click="viewComment(scope.$index, scope.row)"  :disabled="scope.row.type==3">预览
          </el-button>
          <el-button v-if="buttonsAccess.indexOf('操作-删除') > -1 && filters.status !== '-1'" size="small"
            type="danger"
            @click="handleDel(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination :current-page="currentPage" :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, jumper"
        style="float:right" @current-change="handleCurrentChange">
      </el-pagination>
    </el-col>
    
    <!--回复界面-->
    <el-dialog :close-on-click-modal="false" :visible.sync="replayFormVisible" title="评论回复">
      <el-form ref="replayForm" :model="replayForm" :rules="replayFormRules" label-width="80px">
        <el-form-item label="回复内容" label-width="100px" prop="replayContent">
          <el-input v-model.trim="replayForm.replayContent" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="replayFormVisible = false">取消</el-button>
        <el-button :loading="replayLoading" type="primary" @click.native="replaySubmit()">提交</el-button>
      </div>
    </el-dialog>
    
    <el-table v-loading="replayLoading" :data="replayList" border highlight-current-row style="width: 100%;">
      <el-table-column label="回复内容" prop="content" show-overflow-tooltip width="500">
      </el-table-column>
      <el-table-column label="回复时间" prop="createTime" width="200">
      </el-table-column>
      <el-table-column label="回复人" min-width="80" prop="userName">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="small" type="danger" @click="handleDelReplay(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination :current-page="currentPageReplay" :page-size="pageSizeReplay"
        :total="totalReplay"
        layout="total, prev, pager, next, jumper"
        style="float:right" @current-change="handleCurrentChangeReplay">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from '../../common/js/util'
import { deleteComment, deleteReplay, listComment, replayComment, replayList } from '@/api/api'

export default {
  data() {
    return {
      //按钮权限
      buttonsAccess: this.$storejs.get(process.env.VUE_APP_APPKEY + 'userAccess')[this.$route.meta.id] ? this.$storejs.get(process.env.VUE_APP_APPKEY + 'userAccess')[this.$route.meta.id].buttons : [],
      commentList: [],
      replayList: [],
      multipleSelection: [],
      replayFormVisible: false,
      replayForm: {
        replayContent: '',
        commentId: ''
      },
      replayFormRules: {
        replayContent: [
          {required: true, message: '请填写回复内容', trigger: 'blur'}
        ]
      },
      filters: {
        newsname: '',
        status: '0',
        type:"",
        beginDate: new Date() - 1,
        endDate: new Date
      },
      total: 0,
      pageSize: 10,
      page: 1,
      currentPage: 1,
      totalReplay: 0,
      pageSizeReplay: 10,
      pageReplay: 1,
      currentPageReplay: 1,
      listLoading: false,
      replayLoading: false,
      tyypeum:{
        1:'医博士',
        2:'资讯',
        3:'短视频'
      }
    }
  },
  mounted() {
    const day1 = new Date()
    day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
    var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
    this.filters.beginDate = new Date(s1)
    this.getInitList()
  },
  methods: {
    
    viewComment(index, row) {
      window.open(process.env.VUE_APP_YIBOSHI_URL + 'videoPlayer?cId=' + row.id + '&p=true')
    },
    
    handleAuditing() {//批量审核
      this.$confirm('确定批量审核所选评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this
        const formData = new FormData()
        var po = ''
        for (var index in this.multipleSelection) {
          po += this.multipleSelection[index]._id + ','
        }
        if (po.length > 1) {
          po = po.substring(0, po.length - 1)
        } else {
          _this.$message({
            type: 'warning',
            message: '请选择数据'
          })
          return false
        }
        formData.append('_id', po)
        formData.append('type', 2)
        formData.append('value', 1)
        
        deleteComment(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getInitList()
          } else {
            this.$message({
              type: 'warning',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    
    handleCancelAuditing() {//取消批量审核
      this.$confirm('确定批量取消审核所选评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this
        const formData = new FormData()
        var po = ''
        for (var index in this.multipleSelection) {
          po += this.multipleSelection[index]._id + ','
        }
        if (po.length > 1) {
          po = po.substring(0, po.length - 1)
        } else {
          _this.$message({
            type: 'warning',
            message: '请选择数据'
          })
          return false
        }
        
        formData.append('_id', po)
        formData.append('type', 2)
        formData.append('value', 0)
        
        deleteComment(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getInitList()
          } else {
            this.$message({
              type: 'warning',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      this.getInitList()
    },
    
    handleCurrentChangeReplay(val) {
      this.currentPageReplay = val
      this.getReplayList()
    },
    
    //获取评论列表
    getInitList() {
      if (this.filters.beginDate == '' || this.filters.endDate == '') {
        this.$notify({
          type: 'info',
          message: '请选择要查询的时间!'
        })
        return
      }
      var param = {
        typeId: this.filters.type,
        pageNum: this.currentPage,
        status: this.filters.status,
        beginDate: (!this.filters.beginDate || this.filters.beginDate == '') ? '' : util.formatDate.format(new Date(this.filters.beginDate), 'yyyy-MM-dd hh:mm:ss'),
        endDate: (!this.filters.endDate || this.filters.endDate == '') ? '' : util.formatDate.format(new Date(this.filters.endDate), 'yyyy-MM-dd hh:mm:ss')
      }
      this.listLoading = true
      listComment(param).then((res) => {
        this.total = res.data.data.count
        this.commentList = res.data.data.list
        this.listLoading = false
      })
    },
    
    getReplayList() {
      var param = {commentId: this.replayForm.commentId, pageNum: this.currentPageReplay}
      this.replayLoading = true
      replayList(param).then((res) => {
        this.totalReplay = res.data.data.count
        this.replayList = res.data.data.list
        this.replayLoading = false
      })
    },
    
    //获取评论回复列表
    handleReplayList(row, column) {
      if (column.label != '操作' && column.label != undefined) {
        this.replayForm.commentId = row._id
        this.getReplayList()
      }
    },
    
    
    handleSelectionChange(val) {//多选
      this.multipleSelection = val
    },
    
    handleDel(index, row) {//删除评论
      this.$confirm('确认要删除该评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const formData = new FormData()
        formData.append('_id', row._id)
        formData.append('type', 1)
        formData.append('value', 1)
        
        deleteComment(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getInitList()
          } else {
            this.$message({
              type: 'warning',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    
    handleDelReplay(index, row) {//删除评论回复
      this.$confirm('确认要删除回复论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const formData = new FormData()
        formData.append('_id', row._id)
        deleteReplay(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getReplayList()
          } else {
            this.$message({
              type: 'warning',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    
    handleDelBatch() {//批量删除
      this.$confirm('确定批量删除所选评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this
        var po = ''
        for (var index in this.multipleSelection) {
          po += this.multipleSelection[index]._id + ','
        }
        if (po.length > 1) {
          po = po.substring(0, po.length - 1)
        } else {
          _this.$message({
            type: 'warning',
            message: '请选择数据'
          })
          return false
        }
        const formData = new FormData()
        formData.append('_id', po)
        formData.append('type', 1)
        formData.append('value', 1)
        
        deleteComment(formData).then((response) => {
          var data = response.data
          if (data.status == 200) {
            this.$message({
              type: 'success',
              message: data.msg
            })
            this.getInitList()
          } else {
            this.$message({
              type: 'warning',
              message: data.msg
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    
    handleReplay(index, row) {
      this.replayForm.replayContent = ''
      this.replayFormVisible = true
      this.replayForm.commentId = row._id
    },
    
    replaySubmit() {
      this.$refs.replayForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认回复吗？', '提示', {}).then(() => {
            this.replayLoading = true
            const formData = new FormData()
            formData.append('replayContent', this.replayForm.replayContent)
            formData.append('commentId', this.replayForm.commentId)
            replayComment(formData).then((response) => {
              var data = response.data
              if (data.status == 200) {
                this.$message({
                  type: 'success',
                  message: data.msg
                })
                this.replayLoading = false
                this.replayFormVisible = false
                this.getInitList()
              } else {
                this.$message({
                  type: 'warning',
                  message: data.msg
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
        }
      })
    }
    
  }
}
</script>

<style scoped>
</style>
